import * as ActionType from '../../constants/constant_action_types';

const INITIAL_STATE = {
  data: {},
  modal          : {
    state : 'hide',
    header: '',
    index : 0
  },
  pagination: {
    page   : 1,
    perPage: 10
  },
  preferences: {},
};

export default function inventoryStocktakeReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case ActionType.SET_INVENTORY_STOCKTAKE: {
      let result = {
        ...state, data: { ...action.data }
      };

      return result;
    }

    case ActionType.CLEAR_INVENTORY_STOCKTAKE: {
      return {
        ...INITIAL_STATE
      }
    }

    case ActionType.OPEN_INVENTORY_STOCKTAKE_REFERENCE_ID_MODAL: {
      return {
        ...state, modal: {
          state : action.state,
          header: action.header,
          index : action.index
        }
      }
    }


    case ActionType.SET_STOCKTAKE_FORM_LINE_PAGINATION: {
      return {
        ...state, 
        pagination: action.pagination
      }
    }

    case ActionType.SET_STOCKTAKE_PREFERENCES: {
      return {
        ...state, 
        preferences: action.preferences
      }
    }


    default:
      return state;
  }
}